module.exports = __webpack_public_path__ + "static/img/enlarge-square-1.25feb0e4.png";